require("./snippets/accordion");
require("./snippets/v3-accordion");
require("./snippets/product-quick-view-modal");
require("./qf/global_listeners");
// require("./snippets/gdpr-consent");
// require("./qf/wishlist");
require("./qf/wishlistAsObject");
require("./qf/cart");
require("./qf/loadMore");
require("./qf/ModalController");

window.modalController = new ModalController()
// window.wishlist = new WishlistQf();
window.wishlist = new WishlistObjectQf();
window.globalListeners = new GlobalListeners();
window.cart = new CartQf();